const presets = {
    createDefaultLayout() {
        return {
            navWidth: 220,
            navAnchor: 'left',
            navVariant: 'persistent',
            collapsible: true,
            collapsedWidth: 64,
            clipped: true,
            headerPosition: 'sticky',
            squeezed: true,
            footerShrink: true,
        };
    },
    createContentBasedLayout: config => ({
        ...presets.createDefaultLayout(),
        navWidth: 256,
        navVariant: 'persistent',
        collapsible: true,
        ...config,
    }),
};

export default presets;
